(() => {
	const variantGroup = document.querySelectorAll('.product-variants__block');
	variantGroup.forEach(group => {
		const button = group.querySelector('.product-variants__toggle');
		const wrapper = group.querySelector('.product-variants__dropdown-options-wrapper');
		const variants = group.querySelectorAll('.product-variants__btn--dropdown');
		const selectedVariant = group.querySelector('.product-variants__toggle span');

		if (selectedVariant != null) {
			button.addEventListener('click', () => {
				if(wrapper.classList.contains('product-variants__dropdown-options-wrapper--opened')) {
					wrapper.classList.remove('product-variants__dropdown-options-wrapper--opened');
				} else {
					const openedVariantSelectors = document.querySelectorAll('.product-variants__dropdown-options-wrapper--opened');
					openedVariantSelectors.forEach(selector => selector.classList.remove('product-variants__dropdown-options-wrapper--opened'));
					wrapper.classList.add('product-variants__dropdown-options-wrapper--opened');
				}
			});

			variants.forEach(variant => {
				if (variant.classList.contains('product-variants__btn--checked')) {
					selectedVariant.innerHTML = variant.innerHTML;
				}

				variant.addEventListener('click', () => {
					wrapper.classList.remove('product-variants__dropdown-options-wrapper--opened');
					selectedVariant.innerHTML = variant.innerHTML;
				});
			});
		}
	});

	const selectedVariantOption = event => {
		const clickedOption = event.target;
		
		if (!clickedOption.classList.contains('product-variants__btn--disabled')) {
			const clickedOptionId = clickedOption.getAttribute('data-variant-id');
			const currentVariantsBlock = clickedOption.closest('.js-variants');
			const selectionsList = currentVariantsBlock.getAttribute('data-variant-selections') ? currentVariantsBlock.getAttribute('data-variant-selections').split(',') : [];
			const allOptions = currentVariantsBlock.querySelectorAll('.js-variant-option');
			const currentToggle = clickedOption.closest('.product-variants__block').querySelector('.product-variants__toggle span');

			if (!clickedOption.classList.contains('product-variants__btn--checked')) {
				selectionsList.push(clickedOptionId);

				const selectionGroup = currentVariantsBlock.querySelector(`[data-variant-id='${clickedOptionId}']`).getAttribute('data-variant-group');
				allOptions.forEach(optionItem => {
					const availableOptionId = optionItem.getAttribute('data-variant-id');
					if (availableOptionId != clickedOptionId) {
						if (optionItem.getAttribute('data-variant-group') == selectionGroup) {
							removeItemFromArray(selectionsList, availableOptionId);
						}
					}
				});
			} else {
				removeItemFromArray(selectionsList, clickedOptionId);
				currentToggle.innerHTML = currentToggle.dataset.original;

			}
			currentVariantsBlock.setAttribute('data-variant-selections', selectionsList);
			checkIfVariantCompleted(clickedOption.closest('.js-variants'));
		}
	};

	const checkIfVariantCompleted = (currentVariantsBlock, onPageLoad = false) => {
		const reg = new RegExp('\'', 'g');
		const selectedOptions = currentVariantsBlock.getAttribute('data-variant-selections') ? currentVariantsBlock.getAttribute('data-variant-selections').split(',') : [];
		const allOptions = currentVariantsBlock.querySelectorAll('.js-variant-option'); 
		const totalVariantgroups = currentVariantsBlock.getAttribute('data-total-variant-groups');
		const variantCombinations = JSON.parse(currentVariantsBlock.getAttribute('data-combinations').replace(reg, '\"'));

		cleanVariantOptions(allOptions);

		if (selectedOptions.length > 0) {
			const variantOptionsByGroup = JSON.parse(currentVariantsBlock.getAttribute('data-variants').replace(reg, '\"'));

			if (totalVariantgroups > 1) {
				const optionsToHide = getVariantOptionsToHide(variantOptionsByGroup, variantCombinations, selectedOptions);
				optionsToHide.forEach(optionItem => {
					const optionElement = currentVariantsBlock.querySelector(`[data-variant-id='${optionItem}']`);
					excludeVariantOption(optionElement);
				});
			}
		}
		
		selectedOptions.forEach(selection => {
			setVariantSelection(currentVariantsBlock.querySelector(`[data-variant-id='${selection}']`));
		});
		
		if((selectedOptions.length == totalVariantgroups)) {
			const match = variantCombinations.find(arr => selectedOptions.every(opt => arr.includes(opt))) || null;
			if(match) {
				variantSelectionComplete(currentVariantsBlock, onPageLoad, match);
			}
		} else {
			variantSelectionNotComplete(currentVariantsBlock);
		}

	};

	const cleanVariantOptions = allOptions => {
		allOptions.forEach(option => {
			option.disabled = false;
			option.classList.remove('product-variants__btn--disabled');
			option.classList.remove('product-variants__btn--checked');
		});
	};

	const setVariantSelection = selectedOption => {
		selectedOption.classList.add('product-variants__btn--checked');
	};

	const excludeVariantOption = option => {
		option.disabled = true;
		option.classList.add('product-variants__btn--disabled');
	};

	const variantSelectionNotComplete = currentVariantsBlock => {
		const productId = currentVariantsBlock.getAttribute('data-product-id');
		const cartButtons = document.querySelectorAll(`.productdetails__add-to-cart[data-prodid="${productId}"]`);
		const helpText = document.querySelector('.product-variants__feedback');

		cartButtons.forEach(button => {
			button.classList.add('disabled');
		});

		if (helpText) {
			helpText.classList.remove('hidden');
		}
	};

	const variantSelectionComplete = (currentVariantsBlock, onPageLoad, match) => {
		const productId = currentVariantsBlock.getAttribute('data-product-id');
		const cartButtons = document.querySelectorAll(`.productdetails__add-to-cart[data-prodid="${productId}"]`);
		const helpText = document.querySelector('.product-variants__feedback');
		let selectionsList = currentVariantsBlock.getAttribute('data-variant-selections') ? currentVariantsBlock.getAttribute('data-variant-selections').split(',') : [];
		selectionsList = variantSelectionListSort(currentVariantsBlock);
		let currentProduct = currentVariantsBlock.getAttribute('data-current-page-variant').split(',');
		
		if (!onPageLoad) {
			if(selectionsList.toString() !== currentProduct.toString()) {
				const pageId = currentVariantsBlock.getAttribute('data-page-id');
				const groupId = currentVariantsBlock.getAttribute('data-group-id');
				const cleanLink = '/Default.aspx?ID=' + pageId + '&GroupID=' + groupId + '&ProductID=' + productId + '&VariantID=' + match.join('.');

				window.location = cleanLink;
			}
		}

		if (selectionsList.toString() === currentProduct.toString()) {
			cartButtons.forEach(function (button) {
				button.classList.remove('disabled');
			});
			
			if (helpText) {
				helpText.classList.add('hidden');
			}
		}
	};

	const variantSelectionListSort = variantsContainer => {
		const selectionsList = variantsContainer.getAttribute('data-variant-selections') ? variantsContainer.getAttribute('data-variant-selections').split(',') : [];
		let sortedSelectionsList = [];
		const allOptions = variantsContainer.querySelectorAll('.js-variant-option');

		allOptions.forEach(optionItem => {
			const optionId = optionItem.getAttribute('data-variant-id');
			selectionsList.forEach(selectionId => {
				if(optionId === selectionId) {
					sortedSelectionsList.push(selectionId);
				}
			});
		});

		return sortedSelectionsList;
	};

	const getVariantOptionsToHide = (variantOptionsByGroup, variantCombinations, selectedOptions) => {
		const selectedOptionsCount = selectedOptions.length;
		let optionsToHide = [];

		variantOptionsByGroup.forEach(groupIndex => {
			const groupSelectedOption = findSelectedGroupOption(selectedOptionsCount, selectedOptions, groupIndex);
			variantCombinations.forEach(combinationIndex => {
				const showOptionsOfCombination = isValidVariantSelection(combinationIndex, selectedOptionsCount, selectedOptions, groupSelectedOption);
				if (showOptionsOfCombination) {
					showVariantCombinationOptions(combinationIndex, groupIndex);
				}
			});
			optionsToHide = optionsToHide.concat(groupIndex);
		});

		return optionsToHide;
	};

	const isValidVariantSelection = (combinationOptions, selectedCount, selectedOptions, groupSelectedOption) => {
		let count = 0;

		for (let selectionIndex = 0; selectionIndex < selectedCount; selectionIndex++) {
			let selectedOption = selectedOptions[selectionIndex];
			if (selectedOption == groupSelectedOption) {
				count++;
			} else {
				combinationOptions.forEach(optionIndex => {
					if(selectedOption == optionIndex) {
						count++;
					}
				});
			}
		}

		return (selectedCount == count);
	};

	const findSelectedGroupOption = (selectedCount, selectedOptions, groupOptions) => {
		let selectedGroupOption = '';

		for (let selectionIndex = 0; selectionIndex < selectedCount; selectionIndex++) {
			const selectedOption = selectedOptions[selectionIndex];
			groupOptions.forEach(variantIndex => {
				if(selectedOption == variantIndex) {
					selectedGroupOption = selectedOption;
				}
			});
		}

		return selectedGroupOption;
	};

	const showVariantCombinationOptions = (combinationOptions, optionsToHideForThisGroup) => {
		combinationOptions.forEach(optionIndex => removeItemFromArray(optionsToHideForThisGroup, optionIndex));
	};

	const removeItemFromArray = (array, item) => {
		for (var i in array) {
			if (array[i] == item) {
				array.splice(i, 1);
				break;
			}
		}
	};
	
	// Use load event listener because otherwise it won't recognize the Vue injected 'add-to-cart' buttons
	window.addEventListener('load', () => {
		const variantBlocks = document.querySelectorAll('.js-variants');
		if (variantBlocks.length) {
			variantBlocks.forEach(variantBlock => {
				const variantButtons = document.querySelectorAll('.js-variant-option');
				variantButtons.forEach(button => button.addEventListener('click', selectedVariantOption));
				checkIfVariantCompleted(variantBlock, true);
			});
		}
	});

})();
